<template>
	<div class="policy-modal full-screen-modal">
		<div class="header-wrapper">
			<IconTracker :activeType="activeIcon" />
			<h1 class="heading">{{ ui.modal_heading }}</h1>
			<Button class="close-btn" :action="close" />
		</div>
		<TabList class="tab-list" :tabs="plans" :initial-tab="plans[0]" @change="setActiveIcon">
			<template v-slot:tab-label="plan">
				<span>{{ plan.title }}</span>
			</template>
			<template v-slot:tab-body="plan">
				<PurchasedPlans v-bind="plan" />
			</template>
		</TabList>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Button from '@/components/base/Button';
import IconTracker from '@/components/game/header/IconTracker';
import PurchasedPlans from '@/components/game/info-panel/PurchasedPlans';
import TabList from '@/components/base/TabList';

export default {
	name: 'PolicyModal',
	components: {
		Button,
		IconTracker,
		PurchasedPlans,
		TabList,
	},
	data() {
		return {
			activeIcon: null,
		};
	},
	computed: {
		...mapGetters({
			plans: "game/plans/owned",
		}),
		...mapState({
			ui: (state) => state.global.api.data.ui.info.policy,
		}),
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
		setActiveIcon(icon) {
			if (icon.type !== this.activeIcon) {
				this.$store.dispatch("sound/fx/play", { id: "select_plan" });
			}
			this.activeIcon = icon.type;
		},
		close() {
			this.deactivateModal();
			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.heading {
		display: flex;
		justify-content: center;
		font-family: $heading-font;
		font-size: 	$heading-size-sm;
		letter-spacing: $letter-spacing-plus;
		text-transform: uppercase;
		text-align: center;
		line-height: 1;
		position: absolute;
    right: 0;
    left: 0;
    margin: auto;
	}

	.tab-list {
		width: 80%;
		max-width: $max-content-width;
		margin: 40px auto $page-bottom-spacing;
	}
</style>
